module.exports = new __parcel__URL__("testimonial-george.3f5b8295.webp").toString();